var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13c0 7.18-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0c1.333.018 2 .684 2 2 0 1.316-.667 1.982-2 2a9 9 0 1 0 9 9c.012-1.333.678-2 2-2s1.988.667 2 2z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};
export default SvgSpinner;